/* ============================================================
   420 OASIS · V6 "POSTER" · page behaviour (classic script, defer)
   - homepage film: one 2D canvas painted from scroll progress
     (port of paint() in "420 Oasis Storefront Poster.dc.html")
   - header: active chapter underline, live cart count
   - add to cart via /cart/add.js (forms post natively without JS)
   - buy bars, product page (gallery, colour, quantity, FAQ)
   - password page (modal, signup confirmation)
   Every block only runs when its markup is on the page.
   ============================================================ */
(function () {
  'use strict';

  var doc = document;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var mqMobile = window.matchMedia('(max-width: 819px)');
  var mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function onMq(mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); }

  var euro = (function () {
    try { var f = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); return function (cents) { return f.format(cents / 100) + ' €'; }; }
    catch (e) { return function (cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }; }
  })();

  /* ---------- cart ---------- */

  function setCount(n) {
    $$('[data-oposter-cart-count]').forEach(function (el) { el.textContent = String(n); });
    $$('[data-oposter-cart]').forEach(function (el) { el.setAttribute('aria-label', 'Warenkorb, ' + n + ' Artikel'); });
  }

  function addToCart(id, qty) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data && (data.description || data.message) || 'Fehler');
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      });
    }).then(function (r) { return r.json(); }).then(function (cart) {
      setCount(cart.item_count);
      return cart;
    });
  }

  /* Native form posts stay the fallback; fetch only upgrades them. */
  function upgradeForm(form, opts) {
    if (!form || !window.fetch) return;
    form.addEventListener('submit', function (e) {
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      if (!idInput) return;
      e.preventDefault();
      var btn = opts.button ? opts.button() : form.querySelector('[type="submit"]');
      var status = opts.status;
      if (btn) btn.disabled = true;
      if (status) { status.textContent = ''; status.classList.remove('is-error'); }
      addToCart(idInput.value, Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1))
        .then(function () {
          if (status) status.textContent = 'Im Warenkorb.';
          if (opts.done) opts.done();
        })
        .catch(function (err) {
          if (status) { status.textContent = err.message; status.classList.add('is-error'); }
        })
        .then(function () { if (btn) btn.disabled = false; });
    });
  }

  $$('.oposter-card__form').forEach(function (form) {
    upgradeForm(form, { status: form.querySelector('[data-oposter-add-status]') });
  });

  /* ---------- footer contact form: after a post, bring the message into view ---------- */

  var contactDone = $('[data-oposter-contact-done]');
  if (contactDone) {
    contactDone.scrollIntoView({ block: 'center' });
    try { contactDone.focus({ preventScroll: true }); } catch (e) { contactDone.focus(); }
  }

  /* ---------- homepage mobile buy bar ---------- */

  var mobileBar = $('[data-oposter-bar="mobile"]');
  function syncMobileBar() { doc.body.classList.toggle('has-oposter-bar', !!mobileBar && mqMobile.matches); }
  if (mobileBar) { syncMobileBar(); onMq(mqMobile, syncMobileBar); }

  /* ---------- homepage film ---------- */

  var film = $('[data-oposter-film]');
  if (film) initFilm(film);

  function initFilm(story) {
    var cv = $('[data-oposter-canvas]', story);
    var caps = [];
    $$('[data-oposter-cap]', story).forEach(function (el) { caps[Number(el.getAttribute('data-oposter-cap'))] = el; });
    var words = $$('[data-oposter-word]', story);
    var navLinks = $$('[data-oposter-nav]');
    var cur = 0, target = 0, raf = 0, inStory = true, onScreen = true, active = -1, retry = 0;
    var frontCache = null;
    var mobile = mqMobile.matches;
    /* The hero logo is a real image that flies from the hero into the header slot;
       the header logo itself stays invisible until it has landed. */
    var fly = $('[data-oposter-fly]', story);
    var headLogo = $('.oposter-head__logo img');
    var flyH = 0, docked = null;

    function load(src) {
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { paint(cur); };
      if (src) im.src = src;
      return im;
    }
    var tx = {
      logo: load(cv.getAttribute('data-logo')),
      front: load(cv.getAttribute('data-front')),
      spine: load(cv.getAttribute('data-spine')),
      band: load(cv.getAttribute('data-band'))
    };
    function ok(im) { return im && im.complete && im.naturalWidth; }

    function measure() {
      mobile = mqMobile.matches;
      var r = story.getBoundingClientRect(), vh = window.innerHeight;
      target = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - vh)));
      inStory = r.bottom > vh * 0.5;
      onScreen = r.top < vh && r.bottom > 0;
      if (!raf) raf = requestAnimationFrame(step);
    }

    function step() {
      raf = 0;
      /* Reduced motion drops the easing, not the film (desktop sequence always plays). */
      var k = mqReduced.matches ? 1 : 0.12;
      var d = target - cur;
      cur = Math.abs(d) < 0.0003 ? target : cur + d * k;
      /* below the film: nothing to draw, jump straight to the end state */
      if (!onScreen) { cur = target; setActive(4); dock(true); return; }
      paint(cur);
      if (cur !== target) raf = requestAnimationFrame(step);
    }

    function cl(v, a, b) { a = a === undefined ? 0 : a; b = b === undefined ? 1 : b; return Math.min(b, Math.max(a, v)); }
    function ease(t) { return t * t * (3 - 2 * t); }
    function lerp(a, b, t) { return a + (b - a) * t; }

    function paint(p) {
      function seg(a, b) { return ease(cl((p - a) / (b - a))); }
      var W = cv.clientWidth, H = cv.clientHeight;
      if (!W || !H) { clearTimeout(retry); retry = setTimeout(function () { paint(cur); }, 120); return; }
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      if (cv.width !== Math.round(W * dpr) || cv.height !== Math.round(H * dpr)) { cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); }
      var g = cv.getContext('2d');
      g.setTransform(dpr, 0, 0, dpr, 0, 0);
      g.clearRect(0, 0, W, H);

      var GOLD = '#c9a84c', INK = '#111111', TINT = '#efe4c4';
      var cx = W / 2, cy = H * (mobile ? 0.4 : 0.46);
      var bw = Math.min(W * (mobile ? 0.84 : 0.5), 640), bh = bw * (263 / 1137);
      var L = seg(0.03, 0.16), A = seg(0.08, 0.15);
      var T = seg(0.20, 0.28) - seg(0.42, 0.48);
      var G = seg(0.24, 0.31) * (1 - seg(0.44, 0.48));
      var E = seg(0.31, 0.37) - seg(0.40, 0.45);
      var O = seg(0.49, 0.57) - seg(0.85, 0.92);
      var P = seg(0.56, 0.68) - seg(0.80, 0.87);
      var K = seg(0.69, 0.79) - seg(0.81, 0.87);
      var Z = seg(0.92, 1);
      var sc = 1 + 0.12 * Z;

      g.save(); g.translate(cx, cy); g.scale(sc, sc);
      g.lineJoin = 'round'; g.lineWidth = 2;
      var x0 = -bw / 2, y0 = -bh / 2, th = bh * O;

      function img(im, x, y, w, h, a, cover) {
        if (!ok(im) || a <= 0.001) return;
        g.globalAlpha = a;
        if (cover) {
          var ir = im.naturalWidth / im.naturalHeight, r = w / h, sw = im.naturalWidth, sh = im.naturalHeight, sx = 0, sy = 0;
          if (ir > r) { sw = sh * r; sx = (im.naturalWidth - sw) / 2; } else { sh = sw / r; sy = (im.naturalHeight - sh) / 2; }
          g.drawImage(im, sx, sy, sw, sh, x, y, w, h);
        } else g.drawImage(im, x, y, w, h);
        g.globalAlpha = 1;
      }
      function box(x, y, w, h, fill, a) { g.globalAlpha = a; g.fillStyle = fill; g.fillRect(x, y, w, h); g.strokeStyle = INK; g.strokeRect(x, y, w, h); g.globalAlpha = 1; }
      function poly(pts, fill) {
        g.beginPath();
        pts.forEach(function (q, i) { if (i) g.lineTo(q[0], q[1]); else g.moveTo(q[0], q[1]); });
        g.closePath(); g.fillStyle = fill; g.fill(); g.strokeStyle = INK; g.stroke();
      }

      /* opened booklet: the top panel is the paper pocket with a gold slot,
         the bottom panel holds the tips */
      if (th > 1) {
        var slotY = y0 - th * 0.28, slotL = x0 + bw * 0.1, slotR = x0 + bw * 0.9;
        box(x0, y0 - th, bw, th, '#ffffff', 1);

        /* papers are pulled up out of the slot: 110 x 44 mm sheets, slightly
           narrower than the slot, clipped at the slot line so they only exist
           above it. The front sheet comes out furthest, the interleaved ones
           behind it follow a little. */
        if (P > 0.001) {
          var pw = (slotR - slotL) * 0.96, ph = pw * (44 / 110);
          g.save(); g.beginPath(); g.rect(-W, -H * 2, W * 2, slotY + H * 2); g.clip();
          [[0.92, 0, 1], [0.38, 0.012, -1], [0.14, -0.01, 1]].forEach(function (sh) {
            var rise = P * ph * sh[0];
            if (rise < 0.5) return;
            g.save();
            g.translate(sh[1] * bw, slotY);
            g.rotate(sh[2] * 0.02 * P * sh[0]);
            g.fillStyle = '#ffffff'; g.fillRect(-pw / 2, -rise, pw, ph);
            g.strokeStyle = INK; g.lineWidth = 1.5; g.strokeRect(-pw / 2, -rise, pw, ph);
            /* gum strip along the top edge */
            g.globalAlpha = 0.3; g.lineWidth = 1; g.beginPath(); g.moveTo(-pw / 2 + 3, -rise + ph * 0.1); g.lineTo(pw / 2 - 3, -rise + ph * 0.1); g.stroke(); g.globalAlpha = 1;
            g.restore();
          });
          g.restore();
          g.lineWidth = 2;
        }
        /* the slot is drawn over the sheets, so they come out of it */
        g.strokeStyle = GOLD; g.lineWidth = 4; g.beginPath(); g.moveTo(slotL, slotY); g.lineTo(slotR, slotY); g.stroke(); g.lineWidth = 2;

        /* tips: 55 x 25 mm in a 111,7 x 26,7 mm panel, so two stacks side by side */
        box(x0, y0 + bh, bw, th, '#ffffff', 1);
        var tw = bw * (55 / 111.7), tt = th * (25 / 26.7);
        var gap = (bw - tw * 2) / 3, ty = y0 + bh + (th - tt) / 2;
        var tip = function (x, y, a) {
          g.globalAlpha = a; g.fillStyle = '#ffffff'; g.fillRect(x, y, tw, tt);
          g.strokeStyle = INK; g.lineWidth = 1.5; g.strokeRect(x, y, tw, tt); g.globalAlpha = 1; g.lineWidth = 2;
        };
        for (var st = 0; st < 2; st++) {
          var tx0 = x0 + gap + st * (tw + gap);
          /* stack edges peeking out under the top tip */
          g.globalAlpha = 0.35; g.strokeStyle = INK; g.lineWidth = 1;
          g.strokeRect(tx0 + 2, ty + 2, tw, tt - 1);
          g.globalAlpha = 1; g.lineWidth = 2;
          tip(tx0, ty, 1);
        }
        /* three tips tear off the right stack one after another */
        if (K > 0.001) {
          var rx0 = x0 + gap * 2 + tw;
          for (var tk = 2; tk >= 0; tk--) {
            var kt = cl((K - tk * 0.18) / 0.64);
            if (kt <= 0.001) continue;
            g.save();
            /* first straight down, then one to each side, so they stay near the pack */
            var side = [0, 1, -1][tk];
            g.translate(rx0 + tw / 2 + kt * tw * 0.22 * side, ty + tt / 2 + kt * bh * (0.75 + tk * 0.28));
            g.rotate(kt * (0.08 + 0.14 * side + tk * 0.04));
            tip(-tw / 2, -tt / 2, 1);
            g.restore();
          }
        }
      }
      /* tray walls */
      if (T > 0.001) {
        var dd = bh * 0.75 * T, f = dd * 0.5;
        poly([[x0, y0], [x0 - f, y0 - dd], [x0 - f, y0 + bh + dd], [x0, y0 + bh]], TINT);
        poly([[x0 + bw, y0], [x0 + bw + f, y0 - dd], [x0 + bw + f, y0 + bh + dd], [x0 + bw, y0 + bh]], TINT);
        poly([[x0, y0], [x0 + bw, y0], [x0 + bw + f, y0 - dd], [x0 - f, y0 - dd]], '#ffffff');
        poly([[x0, y0 + bh], [x0 + bw, y0 + bh], [x0 + bw + f, y0 + bh + dd], [x0 - f, y0 + bh + dd]], '#ffffff');
      }
      box(x0, y0, bw, bh, '#ffffff', Math.max(A, T, O > 0 ? 1 : 0));
      /* the foil SVG is rasterised once per size; drawing the SVG itself every frame is slow */
      var fa = A * (1 - T) * (1 - O);
      if (fa > 0.001 && ok(tx.front)) {
        var fw = Math.round(bw * dpr * 1.12), fh = Math.round(bh * dpr * 1.12);
        if (!frontCache || frontCache.width !== fw || frontCache.height !== fh) {
          frontCache = frontCache || doc.createElement('canvas');
          frontCache.width = fw; frontCache.height = fh;
          frontCache.getContext('2d').drawImage(tx.front, 0, 0, fw, fh);
        }
        g.globalAlpha = fa; g.drawImage(frontCache, x0, y0, bw, bh); g.globalAlpha = 1;
      }
      img(tx.spine, x0, y0, bw, bh, T * (1 - G) * 0.9);
      if (O > 0.001) {
        if (ok(tx.band)) img(tx.band, x0, y0, bw, bh, O, true);
        else { g.globalAlpha = O; g.fillStyle = GOLD; g.fillRect(x0, y0, bw, bh); g.globalAlpha = 1; }
        g.globalAlpha = O; g.strokeStyle = INK; g.strokeRect(x0, y0, bw, bh); g.globalAlpha = 1;
      }
      /* honeycomb grinder, grows from the tray to the whole screen and back */
      if (G > 0.001) {
        var vx = -cx / sc, vy = -cy / sc, vw = W / sc, vh = H / sc;
        var rx = lerp(x0, vx, E), ry = lerp(y0, vy, E), rw = lerp(bw, vw, E), rh = lerp(bh, vh, E);
        g.save(); g.beginPath(); g.rect(rx, ry, rw, rh); g.clip();
        var r = Math.max(7, bh * 0.13), sx = Math.sqrt(3) * r, sy = 1.5 * r;
        var reach = lerp(bw * 0.56, Math.hypot(vw, vh) * 0.6, E);
        g.fillStyle = GOLD;
        for (var row = Math.floor(ry / sy) - 1; row * sy < ry + rh + sy; row++) {
          for (var col = Math.floor(rx / sx) - 1; col * sx < rx + rw + sx; col++) {
            var hx = col * sx + (row & 1 ? sx / 2 : 0), hy = row * sy;
            var s = G * cl((reach - Math.hypot(hx, hy * 2.2 * (1 - E) + hy * E)) / (r * 4));
            if (s <= 0.01) continue;
            var rr = r * 0.84 * s;
            g.beginPath();
            for (var kk = 0; kk < 6; kk++) {
              var an = Math.PI / 6 + kk * Math.PI / 3, px = hx + rr * Math.cos(an), py = hy + rr * Math.sin(an);
              if (kk) g.lineTo(px, py); else g.moveTo(px, py);
            }
            g.closePath(); g.fill();
          }
        }
        g.restore();
        if (E < 0.99) { g.strokeStyle = INK; g.strokeRect(x0, y0, bw, bh); }
      }
      /* the logo: big between header and hero caption, then into the header
         (fly) or, without the header logo, shrinking onto the pack (canvas) */
      var la = ok(tx.front) ? 1 - A : (1 - T) * (1 - O);
      if (fly && headLogo) {
        flyLogo(L, W, H);
      } else if (la > 0.01 && ok(tx.logo)) {
        var ar = tx.logo.naturalWidth / tx.logo.naturalHeight;
        var cap = caps[0], stTop = cv.getBoundingClientRect().top;
        var capTop = cap ? cap.getBoundingClientRect().top - stTop : H * 0.7;
        var bandT = 68 + 16, bandB = Math.max(bandT + 60, capTop - 24);
        var big = Math.min(H * (mobile ? 0.3 : 0.44), (W * (mobile ? 0.82 : 0.5)) / ar, bandB - bandT) / sc;
        var bandC = ((bandT + bandB) / 2 - cy) / sc;
        var lh = lerp(big, bh * 0.51, L), ly = lerp(bandC, 0, L);
        g.globalAlpha = la; g.drawImage(tx.logo, -lh * ar / 2, ly - lh / 2, lh * ar, lh); g.globalAlpha = 1;
      }
      g.restore();

      var win = [[0.17, 0.47], [0.49, 0.71], [0.67, 0.88]];
      words.forEach(function (el, wi) {
        if (!win[wi]) return;
        var t = cl((p - win[wi][0]) / (win[wi][1] - win[wi][0]));
        var o = Math.min(cl(t / 0.12), cl((1 - t) / 0.12));
        el.style.transform = 'translate3d(' + ((0.5 - t) * W * 0.08).toFixed(1) + 'px, 0, 0)';
        el.style.opacity = o.toFixed(3);
      });

      var op = [
        1 - seg(0.05, 0.08),
        Math.min(seg(0.21, 0.235), 1 - seg(0.435, 0.46)),
        Math.min(seg(0.52, 0.545), 1 - seg(0.675, 0.70)),
        Math.min(seg(0.71, 0.735), 1 - seg(0.845, 0.87)),
        seg(0.925, 0.95)
      ];
      caps.forEach(function (el, ci) {
        if (!el) return;
        el.style.opacity = op[ci].toFixed(3);
        el.style.visibility = op[ci] < 0.01 ? 'hidden' : 'visible';
        el.style.transform = 'translate3d(0, ' + ((1 - op[ci]) * 14).toFixed(1) + 'px, 0)';
      });

      setActive(!inStory ? 4 : p >= 0.70 && p < 0.9 ? 3 : p >= 0.48 && p < 0.70 ? 2 : p >= 0.18 && p < 0.48 ? 1 : 0);
    }

    function dock(on) {
      if (on === docked || !fly || !headLogo) return;
      docked = on;
      fly.classList.toggle('is-flying', !on);
      headLogo.parentNode.classList.toggle('is-docked', on);
    }

    /* t 0: big, centred between header and hero caption; t 1: exactly on the header logo */
    function flyLogo(t, W, H) {
      if (t >= 0.999 || !ok(tx.logo)) { dock(t >= 0.999); return; }
      var ar = tx.logo.naturalWidth / tx.logo.naturalHeight;
      var cr = cv.getBoundingClientRect();
      var cap = caps[0];
      var capTop = cap ? cap.getBoundingClientRect().top - cr.top : H * 0.7;
      var bandT = 68 + 16, bandB = Math.max(bandT + 60, capTop - 24);
      var big = Math.min(H * (mobile ? 0.3 : 0.44), (W * (mobile ? 0.82 : 0.5)) / ar, bandB - bandT);
      var bx = cr.left + W / 2, by = cr.top + (bandT + bandB) / 2;
      var hr = headLogo.getBoundingClientRect();
      var hx = hr.left + hr.width / 2, hy = hr.top + hr.height / 2;
      /* the image is laid out at the big size and only ever scaled down, so it stays sharp */
      if (Math.abs(big - flyH) > 0.5) { flyH = big; fly.style.height = big.toFixed(1) + 'px'; fly.style.width = (big * ar).toFixed(1) + 'px'; }
      var s = lerp(1, hr.height / big, t);
      fly.style.transform = 'translate3d(' + (lerp(bx, hx, t) - big * ar / 2).toFixed(2) + 'px, ' + (lerp(by, hy, t) - big / 2).toFixed(2) + 'px, 0) scale(' + s.toFixed(4) + ')';
      dock(false);
    }

    /* header chapter underline: 1 Tray, 2 Papers, 3 Tips, 4 Shop */
    function setActive(a) {
      if (a !== active) {
        active = a;
        navLinks.forEach(function (el) {
          var on = Number(el.getAttribute('data-oposter-nav')) === a;
          el.classList.toggle('is-active', on);
          if (on) el.setAttribute('aria-current', 'true'); else el.removeAttribute('aria-current');
        });
      }
    }

    window.addEventListener('scroll', measure, { passive: true });
    window.addEventListener('resize', measure);
    onMq(mqMobile, measure);
    if (window.ResizeObserver) new ResizeObserver(function () { paint(cur); }).observe(cv);
    window.addEventListener('load', function () { measure(); paint(cur); });
    setTimeout(function () { measure(); paint(cur); }, 300);
    measure(); cur = target; paint(cur);
  }

  /* ---------- FAQ accordion (one open at a time) ---------- */

  $$('[data-oposter-faq]').forEach(function (list) {
    var qs = $$('.oposter-faq__q', list);
    qs.forEach(function (q) {
      q.addEventListener('click', function () {
        var open = q.getAttribute('aria-expanded') !== 'true';
        qs.forEach(function (o) {
          var on = o === q && open;
          o.setAttribute('aria-expanded', String(on));
          var a = doc.getElementById(o.getAttribute('aria-controls'));
          if (a) a.hidden = !on;
        });
      });
    });
  });

  /* ---------- product page ---------- */

  var pdp = $('[data-opdp]');
  if (pdp) initProduct(pdp);

  function initProduct(pdp) {
    var form = $('[data-opdp-form]', pdp);
    var idInput = form && form.querySelector('[name="id"]');
    var qtyInput = form && form.querySelector('[name="quantity"]');
    var qtyOut = $('[data-opdp-qty]', pdp);
    var addBtn = $('[data-opdp-add]', pdp);
    var status = $('[data-opdp-status]', pdp);
    var bar = $('[data-oposter-bar="sticky"]');
    var barAdd = bar && $('[data-oposter-bar-add]', bar);
    var barQty = bar && $('[data-oposter-bar-qty]', bar);
    var barVariant = bar && $('[data-oposter-bar-variant]', bar);
    var price = Number(pdp.getAttribute('data-price')) || 0;
    var available = pdp.getAttribute('data-available') !== 'false';
    var qty = 1;

    /* gallery tabs */
    var tabs = $$('[data-opdp-thumb]', pdp);
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { pick(i); });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var n = (i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
        pick(n); tabs[n].focus();
      });
    });
    function pick(i) {
      tabs.forEach(function (t, ti) { t.setAttribute('aria-selected', String(ti === i)); t.tabIndex = ti === i ? 0 : -1; });
      $$('[data-opdp-view]', pdp).forEach(function (v, vi) { v.hidden = vi !== i; });
    }

    /* colour swatches (only rendered when the product has a colour option) */
    var swatches = $$('[data-opdp-swatch]', pdp);
    var variantName = $('[data-opdp-variant-name]', pdp);
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (o) { o.setAttribute('aria-pressed', String(o === sw)); });
        if (idInput) idInput.value = sw.getAttribute('data-variant-id');
        price = Number(sw.getAttribute('data-price')) || price;
        available = sw.getAttribute('data-available') !== 'false';
        var name = sw.getAttribute('data-value');
        if (variantName) variantName.textContent = name;
        if (barVariant) barVariant.textContent = name;
        var pv = $('[data-opdp-price]', pdp); if (pv) pv.textContent = euro(price);
        render();
      });
    });

    /* quantity 1 to 20 */
    function setQty(n) { qty = Math.min(20, Math.max(1, n)); render(); }
    var dec = $('[data-opdp-dec]', pdp), inc = $('[data-opdp-inc]', pdp);
    if (dec) dec.addEventListener('click', function () { setQty(qty - 1); });
    if (inc) inc.addEventListener('click', function () { setQty(qty + 1); });

    function render() {
      if (qtyOut) qtyOut.textContent = String(qty);
      if (qtyInput) qtyInput.value = String(qty);
      if (barQty) barQty.textContent = String(qty);
      if (addBtn) {
        addBtn.textContent = available ? 'In den Warenkorb, ' + euro(price * qty) : 'Ausverkauft';
        addBtn.disabled = !available;
      }
      if (barAdd) barAdd.disabled = !available;
    }
    render();

    upgradeForm(form, { status: status, button: function () { return addBtn; }, done: function () { if (status) status.hidden = false; } });
    if (barAdd && form) barAdd.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else if (addBtn) addBtn.click();
    });

    /* sticky bar once the buy section has scrolled away */
    var buy = $('[data-opdp-buy]', pdp);
    if (bar && buy) {
      var shown = false;
      var set = function (show) {
        if (show === shown) return;
        shown = show;
        bar.hidden = !show;
        doc.body.classList.toggle('has-oposter-bar', show);
      };
      if (window.IntersectionObserver) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          set(!e.isIntersecting && e.boundingClientRect.top < 0);
        }, { threshold: 0 }).observe(buy);
      }
      window.addEventListener('scroll', function () { set(buy.getBoundingClientRect().bottom < 0); }, { passive: true });
    }
  }

  /* ---------- password page ---------- */

  var lock = $('[data-oplock]');
  if (lock) initLock(lock);

  function initLock(lock) {
    var modal = $('[data-oplock-modal]', lock);
    var panel = modal && $('.oplock__panel', modal);
    var input = modal && $('input[type="password"]', modal);
    var opener = null;

    function open() {
      if (!modal) return;
      opener = doc.activeElement;
      modal.hidden = false;
      setTimeout(function () { if (input) input.focus(); }, 60);
    }
    function close() {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      if (opener && opener.focus) opener.focus();
    }
    function shake() {
      if (!panel) return;
      panel.classList.remove('is-shaking'); void panel.offsetWidth; panel.classList.add('is-shaking');
    }

    $$('[data-oplock-open]', lock).forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-oplock-close]', lock).forEach(function (b) { b.addEventListener('click', close); });
    if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      /* keep Tab inside the dialog */
      if (e.key === 'Tab' && modal && !modal.hidden) {
        var f = $$('button, input, a[href]', modal).filter(function (el) { return !el.disabled && el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    /* wrong password: Shopify reloads the page with the error, reopen and shake */
    if (modal && modal.querySelector('[data-oplock-error]')) { open(); shake(); }

    /* signup posted: the gold confirmation is rendered open; "Zurück" closes it */
    var done = $('[data-oplock-done]', lock);
    /* the overlay is rendered inside the animated intro (a transform makes it the
       containing block for position: fixed), so lift it to the page */
    if (done) lock.appendChild(done);
    if (done && !done.hidden) {
      var back = $('[data-oplock-done-close]', done);
      if (back) {
        try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); }
        back.addEventListener('click', function () { done.hidden = true; });
      }
    }
  }
})();
